var r={formErrorMessage:"lds-form-error-message"};export{r as default};
